function initBackMenu() {
	jQuery('.js-back-menu').each(function() {
		var menu = jQuery(this);

		menu.find('li').each(function() {
			var item = jQuery(this);
			var drop = item.find('ul');
			var link = item.find('a').eq(0);
			if(drop.length) {
				item.addClass('has-drop-down');
				if(link.length) link.addClass('has-drop-down-a');
			}
		});

		var origHtml = menu.html();

		ResponsiveHelper.addRange({
			'..1023': {
				on: function() {
					menu.html(origHtml);

					menu.find('.has-drop-down').backMenu({
						activeClass: 'active',
						opener: '> .has-drop-down-a',
						slider: '> .submenu',
						animSpeed: 400,
						animStart: function(state) {
							if (state) {
								this.holder.parents('.has-drop-down').addClass('.submenu');
								this.holder.siblings().addClass('hidden-item');
							} else {
								this.holder.closest('.submenu').removeClass('.submenu');
								this.holder.siblings().removeClass('hidden-item');
							}
						}
					});
					menu.find('.has-drop-down-sub').backMenu({
						activeClass: 'active',
						opener: '> a',
						slider: '> .submenu-ul',
						animSpeed: 400,
						animStart: function(state) {
							if (state) {
								this.holder.parents('.has-drop-down-sub').addClass('.submenu-ul');
								this.holder.siblings().addClass('hidden-item');
							} else {
								this.holder.closest('.submenu-ul').removeClass('.submenu-ul');
								this.holder.siblings().removeClass('hidden-item');
							}
						}
					});
				}
			},
			'1024..': {
				on: function() {
					menu.html(origHtml);

					menu.find('> ul').each(function(){
						new TouchNav({
							navBlock: this,
							menuDrop: '.submenu'
						});
					});
				}
			}
		});
	});
}

// mobile menu init
function initMobileNav() {
	jQuery('html').mobileNav({
		hideOnClickOutside: true,
		menuActiveClass: 'nav-active',
		menuOpener: '.nav-opener',
		menuDrop: '.mobile-drop',
		afterHide: function() {
			jQuery('.js-back-menu .has-drop-down').each(function() {
				var inst = jQuery(this).data('BackMenu');
				inst && inst.hideSlide(true);
			});
		}
	});

	jQuery('body').mobileNav({
		hideOnClickOutside: true,
		menuActiveClass: 'search-active',
		menuOpener: '.search-opener',
		menuDrop: '.search-drop'
	});

	jQuery('body').mobileNav({
		hideOnClickOutside: true,
		menuActiveClass: 'filter-active',
		menuOpener: '.filter-opener',
		menuDrop: '.filter-drop'
	});
}

// add classes if item has dropdown
function initDropDownClasses() {
	jQuery('.mobile-drop li').each(function() {
		var item = jQuery(this);
		var drop = item.find('div');
		var link = item.find('a').eq(0);
		if (drop.length) {
			if(drop[0].className != "mother_wrapper") {
				item.addClass('has-drop-down');
				if (link.length) link.addClass('has-drop-down-a');
			}
		}
	});

	jQuery('.submenu .submenu-list').each(function() {
		var item = jQuery(this);
		var drop = item.find('ul');
		var link = item.find('strong').eq(0);
		if (drop.length) {
			item.addClass('has-drop-down-sub');
			if(link.length) link.addClass('has-drop-down-strong');
		}
	});

	jQuery('.tools-block .search').each(function() {
		var item = jQuery(this);
		var drop = item.find('div');
		var link = item.find('a').eq(0);
		if (drop.length) {
			item.addClass('has-drop-down-search');
			if (link.length) link.addClass('search-opener');
		}
	});

	jQuery('.tools-block .cart').each(function() {
		var item = jQuery(this);
		var drop = item.find('div');
		var link = item.find('a').eq(0);
		if (drop.length) {
			item.addClass('has-drop-down-cart');
			if (link.length) link.addClass('has-drop-down-cart-a');
		}
	});

	jQuery('.filter-drop li').each(function() {
		var item = jQuery(this);
		var drop = item.find('div');
		var link = item.find('a').eq(0);
		if (drop.length) {
			item.addClass('has-drop-down-filter');
			if(link.length) link.addClass('has-drop-down-filter-a');
		}
	});
}

// open-close init
function initOpenClose() {
	jQuery('.has-drop-down-cart').openClose({
		hideOnClickOutside: true,
		activeClass: 'active',
		opener: '.has-drop-down-cart-a',
		slider: '.submenu',
		animSpeed: 300,
		effect: 'fade'
	});

	jQuery('.has-drop-down-search').openClose({
		hideOnClickOutside: true,
		activeClass: 'active',
		opener: '.search-opener',
		slider: '.submenu',
		animSpeed: 300,
		effect: 'fade'
	});

	jQuery('.has-drop-down-filter').openClose({
		hideOnClickOutside: true,
		activeClass: 'active',
		opener: '.has-drop-down-filter-a',
		slider: '.submenu',
		animSpeed: 400,
		effect: 'fade'
	});
}

/*
* Responsive Layout helper
*/
ResponsiveHelper = (function($){
// init variables
var handlers = [],
prevWinWidth,
win = $(window),
nativeMatchMedia = false;

// detect match media support
if(window.matchMedia) {
	if(window.Window && window.matchMedia === Window.prototype.matchMedia) {
		nativeMatchMedia = true;
	} else if(window.matchMedia.toString().indexOf('native') > -1) {
		nativeMatchMedia = true;
	}
}

// prepare resize handler
function resizeHandler() {
	var winWidth = win.width();
	if(winWidth !== prevWinWidth) {
		prevWinWidth = winWidth;

// loop through range groups
$.each(handlers, function(index, rangeObject){
	// disable current active area if needed
	$.each(rangeObject.data, function(property, item) {
		if(item.currentActive && !matchRange(item.range[0], item.range[1])) {
			item.currentActive = false;
			if(typeof item.disableCallback === 'function') {
				item.disableCallback();
			}
		}
	});

	// enable areas that match current width
	$.each(rangeObject.data, function(property, item) {
		if(!item.currentActive && matchRange(item.range[0], item.range[1])) {
			// make callback
			item.currentActive = true;
			if(typeof item.enableCallback === 'function') {
				item.enableCallback();
			}
		}
	});
});
}
}
win.bind('load resize orientationchange', resizeHandler);

// test range
function matchRange(r1, r2) {
	var mediaQueryString = '';
	if(r1 > 0) {
		mediaQueryString += '(min-width: ' + r1 + 'px)';
	}
	if(r2 < Infinity) {
		mediaQueryString += (mediaQueryString ? ' and ' : '') + '(max-width: ' + r2 + 'px)';
	}
	return matchQuery(mediaQueryString, r1, r2);
}

// media query function
function matchQuery(query, r1, r2) {
	if(window.matchMedia && nativeMatchMedia) {
		return matchMedia(query).matches;
	} else if(window.styleMedia) {
		return styleMedia.matchMedium(query);
	} else if(window.media) {
		return media.matchMedium(query);
	} else {
		return prevWinWidth >= r1 && prevWinWidth <= r2;
	}
}

// range parser
function parseRange(rangeStr) {
	var rangeData = rangeStr.split('..');
	var x1 = parseInt(rangeData[0], 10) || -Infinity;
	var x2 = parseInt(rangeData[1], 10) || Infinity;
	return [x1, x2].sort(function(a, b){
		return a - b;
	});
}

// export public functions
return {
	addRange: function(ranges) {
// parse data and add items to collection
var result = {data:{}};
$.each(ranges, function(property, data){
	result.data[property] = {
		range: parseRange(property),
		enableCallback: data.on,
		disableCallback: data.off
	};
});
handlers.push(result);

// call resizeHandler to recalculate all events
prevWinWidth = null;
resizeHandler();
}
};
}(jQuery));

/*
* Simple Mobile Navigation
*/
;(function($) {
	function MobileNav(options) {
		this.options = $.extend({
			container: null,
			hideOnClickOutside: false,
			menuActiveClass: 'nav-active',
			menuOpener: '.nav-opener',
			menuDrop: '.nav-drop',
			toggleEvent: 'click',
			outsideClickEvent: 'click touchstart pointerdown MSPointerDown'
		}, options);
		this.initStructure();
		this.attachEvents();
	}
	MobileNav.prototype = {
		initStructure: function() {
			this.page = $('html');
			this.container = $(this.options.container);
			this.opener = this.container.find(this.options.menuOpener);
			this.drop = this.container.find(this.options.menuDrop);
		},
		attachEvents: function() {
			var self = this;

			if(activateResizeHandler) {
				activateResizeHandler();
				activateResizeHandler = null;
			}

			this.outsideClickHandler = function(e) {
				if(self.isOpened()) {
					var target = $(e.target);
					if(!target.closest(self.opener).length && !target.closest(self.drop).length) {
						self.hide();
					}
				}
			};

			this.openerClickHandler = function(e) {
				e.preventDefault();
				self.toggle();
			};

			this.opener.on(this.options.toggleEvent, this.openerClickHandler);
		},
		isOpened: function() {
			return this.container.hasClass(this.options.menuActiveClass);
		},
		show: function() {
			this.container.addClass(this.options.menuActiveClass);
			if(this.options.hideOnClickOutside) {
				this.page.on(this.options.outsideClickEvent, this.outsideClickHandler);
			}
		},
		hide: function() {
			this.container.removeClass(this.options.menuActiveClass);
			if(this.options.hideOnClickOutside) {
				this.page.off(this.options.outsideClickEvent, this.outsideClickHandler);
			}
		},
		toggle: function() {
			if(this.isOpened()) {
				this.hide();
			} else {
				this.show();
			}
		},
		destroy: function() {
			this.container.removeClass(this.options.menuActiveClass);
			this.opener.off(this.options.toggleEvent, this.clickHandler);
			this.page.off(this.options.outsideClickEvent, this.outsideClickHandler);
		}
	};

	var activateResizeHandler = function() {
		var win = $(window),
		doc = $('html'),
		resizeClass = 'resize-active',
		flag, timer;
		var removeClassHandler = function() {
			flag = false;
			doc.removeClass(resizeClass);
		};
		var resizeHandler = function() {
			if(!flag) {
				flag = true;
				doc.addClass(resizeClass);
			}
			clearTimeout(timer);
			timer = setTimeout(removeClassHandler, 500);
		};
		win.on('resize orientationchange', resizeHandler);
	};

	$.fn.mobileNav = function(options) {
		return this.each(function() {
			var params = $.extend({}, options, {container: this}),
			instance = new MobileNav(params);
			$.data(this, 'MobileNav', instance);
		});
	};
}(jQuery));

/*
* jQuery Open/Close plugin
*/
;(function($) {
	function OpenClose(options) {
		this.options = $.extend({
			addClassBeforeAnimation: true,
			hideOnClickOutside: false,
			activeClass:'active',
			opener:'.opener',
			slider:'.slide',
			animSpeed: 400,
			effect:'fade',
			event:'click'
		}, options);
		this.init();
	}
	OpenClose.prototype = {
		init: function() {
			if (this.options.holder) {
				this.findElements();
				this.attachEvents();
				this.makeCallback('onInit', this);
			}
		},
		findElements: function() {
			this.holder = $(this.options.holder);
			this.opener = this.holder.find(this.options.opener);
			this.slider = this.holder.find(this.options.slider);
		},
		attachEvents: function() {
// add handler
var self = this;
this.eventHandler = function(e) {
	e.preventDefault();
	if (self.slider.hasClass(slideHiddenClass)) {
		self.showSlide();
	} else {
		self.hideSlide();
	}
};
self.opener.bind(self.options.event, this.eventHandler);

// hover mode handler
if (self.options.event === 'over') {
	self.opener.bind('mouseenter', function() {
		if (!self.holder.hasClass(self.options.activeClass)){
			self.showSlide();
		}
	});
	self.holder.bind('mouseleave', function() {
		self.hideSlide();
	});
}

// outside click handler
self.outsideClickHandler = function(e) {
	if (self.options.hideOnClickOutside) {
		var target = $(e.target);
		if (!target.is(self.holder) && !target.closest(self.holder).length) {
			self.hideSlide();
		}
	}
};

// set initial styles
if (this.holder.hasClass(this.options.activeClass)) {
	$(document).bind('click touchstart', self.outsideClickHandler);
} else {
	this.slider.addClass(slideHiddenClass);
}
},
showSlide: function() {
	var self = this;
	if (self.options.addClassBeforeAnimation) {
		self.holder.addClass(self.options.activeClass);
	}
	self.slider.removeClass(slideHiddenClass);
	$(document).bind('click touchstart', self.outsideClickHandler);

	self.makeCallback('animStart', true);
	toggleEffects[self.options.effect].show({
		box: self.slider,
		speed: self.options.animSpeed,
		complete: function() {
			if (!self.options.addClassBeforeAnimation) {
				self.holder.addClass(self.options.activeClass);
			}
			self.makeCallback('animEnd', true);
		}
	});
},
hideSlide: function() {
	var self = this;
	if (self.options.addClassBeforeAnimation) {
		self.holder.removeClass(self.options.activeClass);
	}
	$(document).unbind('click touchstart', self.outsideClickHandler);

	self.makeCallback('animStart', false);
	toggleEffects[self.options.effect].hide({
		box: self.slider,
		speed: self.options.animSpeed,
		complete: function() {
			if (!self.options.addClassBeforeAnimation) {
				self.holder.removeClass(self.options.activeClass);
			}
			self.slider.addClass(slideHiddenClass);
			self.makeCallback('animEnd', false);
		}
	});
},
destroy: function() {
	this.slider.removeClass(slideHiddenClass).css({ display:'' });
	this.opener.unbind(this.options.event, this.eventHandler);
	this.holder.removeClass(this.options.activeClass).removeData('OpenClose');
	$(document).unbind('click touchstart', this.outsideClickHandler);
},
makeCallback: function(name) {
	if (typeof this.options[name] === 'function') {
		var args = Array.prototype.slice.call(arguments);
		args.shift();
		this.options[name].apply(this, args);
	}
}
};

// add stylesheet for slide on DOMReady
var slideHiddenClass = 'js-slide-hidden';
(function() {
	var tabStyleSheet = $('<style type="text/css">')[0];
	var tabStyleRule = '.' + slideHiddenClass;
	tabStyleRule += '{}';
	if (tabStyleSheet.styleSheet) {
		tabStyleSheet.styleSheet.cssText = tabStyleRule;
	} else {
		tabStyleSheet.appendChild(document.createTextNode(tabStyleRule));
	}
	$('head').append(tabStyleSheet);
}());

// animation effects
var toggleEffects = {
	slide: {
		show: function(o) {
			o.box.stop(true).hide().slideDown(o.speed, o.complete);
		},
		hide: function(o) {
			o.box.stop(true).slideUp(o.speed, o.complete);
		}
	},
	fade: {
		show: function(o) {
			o.box.stop(true).hide().fadeIn(o.speed, o.complete);
		},
		hide: function(o) {
			o.box.stop(true).fadeOut(o.speed, o.complete);
		}
	},
	none: {
		show: function(o) {
			o.box.hide().show(0, o.complete);
		},
		hide: function(o) {
			o.box.hide(0, o.complete);
		}
	}
};

// jQuery plugin interface
$.fn.openClose = function(opt) {
	return this.each(function() {
		jQuery(this).data('OpenClose', new OpenClose($.extend(opt, { holder: this })));
	});
};
}(jQuery));

/*
* jQuery BackMenu plugin
*/
;(function($) {
	function BackMenu(options) {
		this.options = $.extend({
			addClassBeforeAnimation: true,
			hideOnClickOutside: false,
			activeClass:'active',
			opener:'.opener',
			closer:'> .back',
			slider:'.slide',
			animSpeed: 400
		}, options);
		this.init();
	}
	BackMenu.prototype = {
		init: function() {
			if (this.options.holder) {
				this.findElements();
				this.attachEvents();
				this.makeCallback('onInit', this);
			}
		},
		findElements: function() {
			this.holder = $(this.options.holder);
			this.opener = this.holder.find(this.options.opener);
			this.slider = this.holder.find(this.options.slider);
			this.closer = this.slider.find(this.options.closer);
		},
		attachEvents: function() {
// add handler
var self = this;
this.eventHandler = function(e) {
	e.preventDefault();
	if (self.slider.hasClass(slideHiddenClass)) {
		self.showSlide();
	} else {
		self.hideSlide();
	}
};
this.closeHandler = function(e) {
	e.preventDefault();
	self.hideSlide();
};

self.opener.on('click', this.eventHandler);
self.closer.on('click', this.closeHandler);

// outside click handler
self.outsideClickHandler = function(e) {
	if (self.options.hideOnClickOutside) {
		var target = $(e.target);
		if (!target.is(self.holder) && !target.closest(self.holder).length) {
			self.hideSlide();
		}
	}
};

// set initial styles
if (this.holder.hasClass(this.options.activeClass)) {
	$(document).on('click touchstart', self.outsideClickHandler);
} else {
	this.slider.addClass(slideHiddenClass);
}
},
showSlide: function() {
	var self = this;
	if (self.options.addClassBeforeAnimation) {
		self.holder.addClass(self.options.activeClass);
	}
	self.slider.removeClass(slideHiddenClass);
	$(document).on('click touchstart', self.outsideClickHandler);

	self.makeCallback('animStart', true);

	clearTimeout(this.timer);

	this.timer = setTimeout(function() {
		if (!self.options.addClassBeforeAnimation) {
			self.holder.addClass(self.options.activeClass);
		}
		self.makeCallback('animEnd', true);
	}, self.options.animSpeed);
},
hideSlide: function(noAnim) {
	var self = this;
	if (self.options.addClassBeforeAnimation) {
		self.holder.removeClass(self.options.activeClass);
	}
	self.slider.addClass(slideHiddenClass);
	$(document).off('click touchstart', self.outsideClickHandler);

	self.makeCallback('animStart', false);

	clearTimeout(this.timer);

	this.timer = setTimeout(function() {
		if (!self.options.addClassBeforeAnimation) {
			self.holder.removeClass(self.options.activeClass);
		}
		self.makeCallback('animEnd', false);
	}, noAnim ? 0 : self.options.animSpeed);
},
destroy: function() {
	this.slider.removeClass(slideHiddenClass).css({ display:'' });
	this.opener.off('click', this.eventHandler);
	this.closer.off('click', this.closeHandler);
	this.holder.removeClass(this.options.activeClass).removeData('BackMenu');
	$(document).off('click touchstart', this.outsideClickHandler);
},
makeCallback: function(name) {
	if (typeof this.options[name] === 'function') {
		var args = Array.prototype.slice.call(arguments);
		args.shift();
		this.options[name].apply(this, args);
	}
}
};

// add stylesheet for slide on DOMReady
var slideHiddenClass = 'js-slide-hidden';

// jQuery plugin interface
$.fn.backMenu = function(opt) {
	return this.each(function() {
		jQuery(this).data('BackMenu', new BackMenu($.extend(opt, { holder: this })));
	});
};
}(jQuery));

/*
* Simple Mobile Navigation
*/
;(function($) {
	function MobileNav(options) {
		this.options = $.extend({
			container: null,
			hideOnClickOutside: false,
			menuActiveClass: 'nav-active',
			menuOpener: '.nav-opener',
			menuDrop: '.nav-drop',
			toggleEvent: 'click',
			outsideClickEvent: 'click touchstart pointerdown MSPointerDown'
		}, options);
		this.initStructure();
		this.attachEvents();
	}
	MobileNav.prototype = {
		initStructure: function() {
			this.page = $('html');
			this.container = $(this.options.container);
			this.opener = this.container.find(this.options.menuOpener);
			this.drop = this.container.find(this.options.menuDrop);
		},
		attachEvents: function() {
			var self = this;

			if(activateResizeHandler) {
				activateResizeHandler();
				activateResizeHandler = null;
			}

			this.outsideClickHandler = function(e) {
				if(self.isOpened()) {
					var target = $(e.target);
					if(!target.closest(self.opener).length && !target.closest(self.drop).length) {
						self.hide();
					}
				}
			};

			this.openerClickHandler = function(e) {
				e.preventDefault();
				self.toggle();
			};

			this.opener.on(this.options.toggleEvent, this.openerClickHandler);
		},
		isOpened: function() {
			return this.container.hasClass(this.options.menuActiveClass);
		},
		show: function() {
			this.makeCallback('beforeShow', this);
			this.container.addClass(this.options.menuActiveClass);
			if(this.options.hideOnClickOutside) {
				this.page.on(this.options.outsideClickEvent, this.outsideClickHandler);
			}
			this.makeCallback('afterShow', this);
		},
		hide: function() {
			this.makeCallback('beforeHide', this);
			this.container.removeClass(this.options.menuActiveClass);
			if(this.options.hideOnClickOutside) {
				this.page.off(this.options.outsideClickEvent, this.outsideClickHandler);
			}
			this.makeCallback('afterHide', this);
		},
		toggle: function() {
			if(this.isOpened()) {
				this.hide();
			} else {
				this.show();
			}
		},
		destroy: function() {
			this.container.removeClass(this.options.menuActiveClass);
			this.opener.off(this.options.toggleEvent, this.clickHandler);
			this.page.off(this.options.outsideClickEvent, this.outsideClickHandler);
		},
		makeCallback: function(name) {
			if (typeof this.options[name] === 'function') {
				var args = Array.prototype.slice.call(arguments);
				args.shift();
				this.options[name].apply(this, args);
			}
		}
	};

	var activateResizeHandler = function() {
		var win = $(window),
		doc = $('html'),
		resizeClass = 'resize-active',
		flag, timer;
		var removeClassHandler = function() {
			flag = false;
			doc.removeClass(resizeClass);
		};
		var resizeHandler = function() {
			if(!flag) {
				flag = true;
				doc.addClass(resizeClass);
			}
			clearTimeout(timer);
			timer = setTimeout(removeClassHandler, 500);
		};
		win.on('resize orientationchange', resizeHandler);
	};

	$.fn.mobileNav = function(options) {
		return this.each(function() {
			var params = $.extend({}, options, {container: this}),
			instance = new MobileNav(params);
			$.data(this, 'MobileNav', instance);
		});
	};
}(jQuery));

// navigation accesibility module
function TouchNav(opt) {
	this.options = {
		hoverClass: 'hover',
		menuItems: 'li',
		menuOpener: 'a',
		menuDrop: 'ul',
		navBlock: null
	};
	for (var p in opt) {
		if (opt.hasOwnProperty(p)) {
			this.options[p] = opt[p];
		}
	}
	this.init();
}
TouchNav.isActiveOn = function(elem) {
	return elem && elem.touchNavActive;
};
TouchNav.prototype = {
	init: function() {
		if (typeof this.options.navBlock === 'string') {
			this.menu = document.getElementById(this.options.navBlock);
		} else if (typeof this.options.navBlock === 'object') {
			this.menu = this.options.navBlock;
		}
		if (this.menu) {
			this.addEvents();
		}
	},
	addEvents: function() {
// attach event handlers
var self = this;
var touchEvent = (navigator.pointerEnabled && 'pointerdown') || (navigator.msPointerEnabled && 'MSPointerDown') || (this.isTouchDevice && 'touchstart');
this.menuItems = lib.queryElementsBySelector(this.options.menuItems, this.menu);

var initMenuItem = function(item) {
	var currentDrop = lib.queryElementsBySelector(self.options.menuDrop, item)[0],
	currentOpener = lib.queryElementsBySelector(self.options.menuOpener, item)[0];

// only for touch input devices
if (currentDrop && currentOpener && (self.isTouchDevice || self.isPointerDevice)) {
	lib.event.add(currentOpener, 'click', lib.bind(self.clickHandler, self));
	lib.event.add(currentOpener, 'mousedown', lib.bind(self.mousedownHandler, self));
	lib.event.add(currentOpener, touchEvent, function(e) {
		if (!self.isTouchPointerEvent(e)) {
			self.preventCurrentClick = false;
			return;
		}
		self.touchFlag = true;
		self.currentItem = item;
		self.currentLink = currentOpener;
		self.pressHandler.apply(self, arguments);
	});
}
// for desktop computers and touch devices
jQuery(item)
.bind('mouseenter', function() {
	if (!self.touchFlag) {
		self.currentItem = item;
		self.mouseoverHandler();
	}
});
jQuery(item)
.bind('mouseleave', function() {
	if (!self.touchFlag) {
		self.currentItem = item;
		self.mouseoutHandler();
	}
});
item.touchNavActive = true;
};

// addd handlers for all menu items
for (var i = 0; i < this.menuItems.length; i++) {
	initMenuItem(self.menuItems[i]);
}

// hide dropdowns when clicking outside navigation
if (this.isTouchDevice || this.isPointerDevice) {
	lib.event.add(document.documentElement, 'mousedown', lib.bind(this.clickOutsideHandler, this));
	lib.event.add(document.documentElement, touchEvent, lib.bind(this.clickOutsideHandler, this));
}
},
mousedownHandler: function(e) {
	if (this.touchFlag) {
		e.preventDefault();
		this.touchFlag = false;
		this.preventCurrentClick = false;
	}
},
mouseoverHandler: function() {
	lib.addClass(this.currentItem, this.options.hoverClass);
	jQuery(this.currentItem)
	.trigger('itemhover');
},
mouseoutHandler: function() {
	lib.removeClass(this.currentItem, this.options.hoverClass);
	jQuery(this.currentItem)
	.trigger('itemleave');
},
hideActiveDropdown: function() {
	for (var i = 0; i < this.menuItems.length; i++) {
		if (lib.hasClass(this.menuItems[i], this.options.hoverClass)) {
			lib.removeClass(this.menuItems[i], this.options.hoverClass);
			jQuery(this.menuItems[i])
			.trigger('itemleave');
		}
	}
	this.activeParent = null;
},
pressHandler: function(e) {
// hide previous drop (if active)
if (this.currentItem !== this.activeParent) {
	if (this.activeParent && this.currentItem.parentNode === this.activeParent.parentNode) {
		lib.removeClass(this.activeParent, this.options.hoverClass);
	} else if (!this.isParent(this.activeParent, this.currentLink)) {
		this.hideActiveDropdown();
	}
}
// handle current drop
this.activeParent = this.currentItem;
if (lib.hasClass(this.currentItem, this.options.hoverClass)) {
	this.preventCurrentClick = false;
} else {
	e.preventDefault();
	this.preventCurrentClick = true;
	lib.addClass(this.currentItem, this.options.hoverClass);
	jQuery(this.currentItem)
	.trigger('itemhover');
}
},
clickHandler: function(e) {
// prevent first click on link
if (this.preventCurrentClick) {
	e.preventDefault();
}
},
clickOutsideHandler: function(event) {
	var e = event.changedTouches ? event.changedTouches[0] : event;
	if (this.activeParent && !this.isParent(this.menu, e.target)) {
		this.hideActiveDropdown();
		this.touchFlag = false;
	}
},
isParent: function(parent, child) {
	while (child.parentNode) {
		if (child.parentNode == parent) {
			return true;
		}
		child = child.parentNode;
	}
	return false;
},
isTouchPointerEvent: function(e) {
	return (e.type.indexOf('touch') > -1) ||
	(navigator.pointerEnabled && e.pointerType === 'touch') ||
	(navigator.msPointerEnabled && e.pointerType == e.MSPOINTER_TYPE_TOUCH);
},
isPointerDevice: (function() {
	return !!(navigator.pointerEnabled || navigator.msPointerEnabled);
}()),
isTouchDevice: (function() {
	return !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
}())
};

/*
* Utility module
*/
lib = {
	hasClass: function(el,cls) {
		return el && el.className ? el.className.match(new RegExp('(\\s|^)'+cls+'(\\s|$)')) : false;
	},
	addClass: function(el,cls) {
		if (el && !this.hasClass(el,cls)) el.className += " "+cls;
	},
	removeClass: function(el,cls) {
		if (el && this.hasClass(el,cls)) {el.className=el.className.replace(new RegExp('(\\s|^)'+cls+'(\\s|$)'),' ');}
	},
	extend: function(obj) {
		for(var i = 1; i < arguments.length; i++) {
			for(var p in arguments[i]) {
				if(arguments[i].hasOwnProperty(p)) {
					obj[p] = arguments[i][p];
				}
			}
		}
		return obj;
	},
	each: function(obj, callback) {
		var property, len;
		if(typeof obj.length === 'number') {
			for(property = 0, len = obj.length; property < len; property++) {
				if(callback.call(obj[property], property, obj[property]) === false) {
					break;
				}
			}
		} else {
			for(property in obj) {
				if(obj.hasOwnProperty(property)) {
					if(callback.call(obj[property], property, obj[property]) === false) {
						break;
					}
				}
			}
		}
	},
	event: (function() {
		var fixEvent = function(e) {
			e = e || window.event;
			if(e.isFixed) return e; else e.isFixed = true;
			if(!e.target) e.target = e.srcElement;
			e.preventDefault = e.preventDefault || function() {this.returnValue = false;};
			e.stopPropagation = e.stopPropagation || function() {this.cancelBubble = true;};
			return e;
		};
		return {
			add: function(elem, event, handler) {
				if(!elem.events) {
					elem.events = {};
					elem.handle = function(e) {
						var ret, handlers = elem.events[e.type];
						e = fixEvent(e);
						for(var i = 0, len = handlers.length; i < len; i++) {
							if(handlers[i]) {
								ret = handlers[i].call(elem, e);
								if(ret === false) {
									e.preventDefault();
									e.stopPropagation();
								}
							}
						}
					};
				}
				if(!elem.events[event]) {
					elem.events[event] = [];
					if(elem.addEventListener) elem.addEventListener(event, elem.handle, false);
					else if(elem.attachEvent) elem.attachEvent('on'+event, elem.handle);
				}
				elem.events[event].push(handler);
			},
			remove: function(elem, event, handler) {
				var handlers = elem.events[event];
				for(var i = handlers.length - 1; i >= 0; i--) {
					if(handlers[i] === handler) {
						handlers.splice(i,1);
					}
				}
				if(!handlers.length) {
					delete elem.events[event];
					if(elem.removeEventListener) elem.removeEventListener(event, elem.handle, false);
					else if(elem.detachEvent) elem.detachEvent('on'+event, elem.handle);
				}
			}
		};
	}()),
	queryElementsBySelector: function(selector, scope) {
		scope = scope || document;
		if(!selector) return [];
		if(selector === '>*') return scope.children;
		if(typeof document.querySelectorAll === 'function') {
			return scope.querySelectorAll(selector);
		}
		var selectors = selector.split(',');
		var resultList = [];
		for(var s = 0; s < selectors.length; s++) {
			var currentContext = [scope || document];
			var tokens = selectors[s].replace(/^\s+/,'').replace(/\s+$/,'').split(' ');
			for (var i = 0; i < tokens.length; i++) {
				token = tokens[i].replace(/^\s+/,'').replace(/\s+$/,'');
				if (token.indexOf('#') > -1) {
					var bits = token.split('#'), tagName = bits[0], id = bits[1];
					var element = document.getElementById(id);
					if (element && tagName && element.nodeName.toLowerCase() != tagName) {
						return [];
					}
					currentContext = element ? [element] : [];
					continue;
				}
				if (token.indexOf('.') > -1) {
					var bits = token.split('.'), tagName = bits[0] || '*', className = bits[1], found = [], foundCount = 0;
					for (var h = 0; h < currentContext.length; h++) {
						var elements;
						if (tagName == '*') {
							elements = currentContext[h].getElementsByTagName('*');
						} else {
							elements = currentContext[h].getElementsByTagName(tagName);
						}
						for (var j = 0; j < elements.length; j++) {
							found[foundCount++] = elements[j];
						}
					}
					currentContext = [];
					var currentContextIndex = 0;
					for (var k = 0; k < found.length; k++) {
						if (found[k].className && found[k].className.match(new RegExp('(\\s|^)'+className+'(\\s|$)'))) {
							currentContext[currentContextIndex++] = found[k];
						}
					}
					continue;
				}
				if (token.match(/^(\w*)\[(\w+)([=~\|\^\$\*]?)=?"?([^\]"]*)"?\]$/)) {
					var tagName = RegExp.$1 || '*', attrName = RegExp.$2, attrOperator = RegExp.$3, attrValue = RegExp.$4;
					if(attrName.toLowerCase() == 'for' && this.browser.msie && this.browser.version < 8) {
						attrName = 'htmlFor';
					}
					var found = [], foundCount = 0;
					for (var h = 0; h < currentContext.length; h++) {
						var elements;
						if (tagName == '*') {
							elements = currentContext[h].getElementsByTagName('*');
						} else {
							elements = currentContext[h].getElementsByTagName(tagName);
						}
						for (var j = 0; elements[j]; j++) {
							found[foundCount++] = elements[j];
						}
					}
					currentContext = [];
					var currentContextIndex = 0, checkFunction;
					switch (attrOperator) {
						case '=': checkFunction = function(e) { return (e.getAttribute(attrName) == attrValue) }; break;
						case '~': checkFunction = function(e) { return (e.getAttribute(attrName).match(new RegExp('(\\s|^)'+attrValue+'(\\s|$)'))) }; break;
						case '|': checkFunction = function(e) { return (e.getAttribute(attrName).match(new RegExp('^'+attrValue+'-?'))) }; break;
						case '^': checkFunction = function(e) { return (e.getAttribute(attrName).indexOf(attrValue) == 0) }; break;
						case '$': checkFunction = function(e) { return (e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length) }; break;
						case '*': checkFunction = function(e) { return (e.getAttribute(attrName).indexOf(attrValue) > -1) }; break;
						default : checkFunction = function(e) { return e.getAttribute(attrName) };
					}
					currentContext = [];
					var currentContextIndex = 0;
					for (var k = 0; k < found.length; k++) {
						if (checkFunction(found[k])) {
							currentContext[currentContextIndex++] = found[k];
						}
					}
					continue;
				}
				tagName = token;
				var found = [], foundCount = 0;
				for (var h = 0; h < currentContext.length; h++) {
					var elements = currentContext[h].getElementsByTagName(tagName);
					for (var j = 0; j < elements.length; j++) {
						found[foundCount++] = elements[j];
					}
				}
				currentContext = found;
			}
			resultList = [].concat(resultList,currentContext);
		}
		return resultList;
	},
	trim: function (str) {
		return str.replace(/^\s+/, '').replace(/\s+$/, '');
	},
	bind: function(f, scope, forceArgs){
		return function() {return f.apply(scope, typeof forceArgs !== 'undefined' ? [forceArgs] : arguments);};
	}
};
jQuery(function(){
	initMobileNav();
	initDropDownClasses();
	initOpenClose();
	initBackMenu();
});
